module.exports = __webpack_public_path__ + "img/icon-thumbs-up-regular.5e3eb6fb.svg";